import {Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import {useSnackbar} from 'notistack';
import React, {useEffect} from 'react';
import {RouteComponentProps} from 'react-router-dom';
import useReactRouter from 'use-react-router';
import {LoadingOverlay} from '../../../components/LoadingOverlay/LoadingOverlay';
import {Page} from '../../../components/Page';
import PageHeader from '../../../components/PageHeader';
import {Group, GroupBooking} from '../../../graphql/groups.datatypes';
import getGroupBooking from '../getGroupBooking.api';
import GroupBookingEdit from './GroupBookingEdit';
import getGroup from '../../Groups/getGroup.api';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(3)
  },
}));

const getBlankGroupBooking = (group: Group | null): GroupBooking => {
  return {
    __typename: 'GroupBooking',
    id: -1,
    group_id: group ? group.id : -1,
    soft_cancelled: false,
    disabled: false,
    start_date: group ? group.start_date : '',
    end_date: group ? group.end_date : '',
    group: group ? group : undefined,
  };
};

const GroupBookingDetails = () => {
  const {history, match}: RouteComponentProps<{ id?: string, group_id?: string }> = useReactRouter();
  const classes = useStyles();
  const {id, group_id} = match.params;
  const newGroupBooking = group_id !== undefined;
  const groupData = group_id ? getGroup(Number(group_id)!) : {loading: false, data: null};
  const group = groupData && groupData.data && groupData.data.group ? groupData.data.group : null;
  const groupBookingData = newGroupBooking ? {
    loading: false,
    data: {groupBooking: getBlankGroupBooking(group)},
    error: null
  } : getGroupBooking(Number(id));
  const {enqueueSnackbar} = useSnackbar();
  const title = 'Booking Details';

  useEffect(() => {
    if (groupBookingData.error) {
      console.error(groupBookingData);
      enqueueSnackbar(`There was an error loading Group Booking ${id}`, {variant: 'error'});
      history.push('/groups');
    }
  }, [groupBookingData.error]);

  return (
      <Page className={classes.root} title={title}>
        <PageHeader section="groups" title={title}/>
        <LoadingOverlay loading={groupBookingData.loading || groupData.loading}>
          {groupBookingData.data && groupBookingData.data.groupBooking && (
              <GroupBookingEdit groupBooking={groupBookingData.data.groupBooking}/>)}
        </LoadingOverlay>
      </Page>
  );
};

export default GroupBookingDetails;
